<template>
  <div class="box">
    <div class="chart-title">
      <span>DAILY LP GAIN / LOSS</span>
    </div>
    <e-charts :options="chartOptions" auto-resize></e-charts>
    <div class="chart-range">
      <div>7 played days ago</div>
      <div>today</div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/grid'
import 'echarts/lib/component/tooltip'
import { formatLeaguePositionChange } from '@/utilities'
import state from '../state'

export default {
  props: {
    differences: {
      type: Array,
      required: true,
    },
  },

  components: {
    ECharts,
  },

  computed: {
    orderedDifferences () {
      return this.differences.reverse()
    },
    chartOptions () {
      return {
        grid: {
          left: 0,
          right: 0,
          top: 15,
          bottom: 15,
          width: '100%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'item',
          position: 'bottom',
          formatter ({ name, value }) {
            let day
            if (moment().isSame(moment(name), 'd')) {
              day = 'today'
            } else {
              day = moment(name).endOf('day').fromNow()
            }
            return `
            <div style="text-align:center;">
              ${day}
            <div>
            `
          },
        },
        xAxis: [{
          show: true,
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: state.darkThemeEnabled ? 'rgba(0,0,0,.23)' : '#F1F4F7',
            },
          },
          data: this.orderedDifferences.map(difference => difference.day),
        }],
        yAxis: [{
          show: false,
          axisLabel: {
            inside: true,
          },
        }],
        label: {
          normal: {
            formatter ({ data }) { return formatLeaguePositionChange(data.value) },
          },
          emphasis: {
            formatter ({ data }) { return formatLeaguePositionChange(data.value) },
          },
        },
        series: [{
          type: 'bar',
          itemStyle: {
            normal: {
              color: function (params) {
                if (params.data.value >= 0) {
                  return '#00A7FF'
                }

                return '#FF4678'
              },
            },
          },
          label: {
            normal: {
              show: true,
              position: 'top',
            },
          },
          barWidth: '40%',
          data: this.orderedDifferences.map(difference => difference.difference).map(datapoint => {
            return { value: datapoint, label: { normal: { position: datapoint >= 0 ? 'top' : 'bottom' } } }
          }),
        }],
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../sass/variables'
@import '~bulma/sass/utilities/variables'
@import '~bulma/sass/utilities/mixins'

.echarts
  width: 100%
  height: 200px

.box
  border-top: 4px solid $primary
  padding: 1rem

.chart-title
  margin-top: 1rem
  text-align: center
  span
    display: inline-block
    padding-bottom: 5px
    border-bottom: 1px solid $divider-color

.chart-range
  display: flex
  justify-content: space-between
  margin-top: 1rem
  color: $text-lighter
  font-weight: 300
  font-size: .85rem

.is-dark
  .chart-title span
    border-color: rgba(0,0,0,0.23)
</style>



// WEBPACK FOOTER //
// GainLossGraph.vue?4883b7b6